import React, { useEffect, useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { useNavigate } from "react-router-dom";

// import JS files

import Header from "../../shares/others/Header";

// import others files
import logo from "../../../assets/imgs/logo-footer.svg";
import telegramIcon from "../../../assets/imgs/telegram.svg";
import twitterIcon from "../../../assets/imgs/twitter.svg";
import instagramIcon from "../../../assets/imgs/instagram.svg";
import resane from "../../../assets/imgs/resane.png";


const Footer = (props) => {
  useEffect(() => {
    window.call_resane();
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-myblues-400">
        <div className="grid md:grid-cols-10 gap-8 p-8 ">
          <div className=" md:col-span-4 flex flex-col">
            <img src={logo} className="md:w-1/2" />
            <span className="leading-8 text-white mt-4 text-sm">
              پایگاه خبری مراقب بیمه یک تشکل خبری و رسانه ای در حوزه تخصصی بیمه
              است. در این نهاد خبری تقویت و توسعه صنعت بیمه و نهادینه کردن فرهنگ
              بیمه در بین مردم کشور عزیزمان را سرلوحه کار و فعالیت خود قرار داده
              ایم و این اهداف متعالی را به مثابه ماموریت خبرگزاری تعریف کرده
              ایم.
            </span>
          </div>
          <div className="md:col-span-2">
            <Header whiteColor smallSize header="دسترسی سریع" noAllItems />
            <ul className="text-white">
              <li className="my-4" onClick={() => navigate("/news-list")}>
                <a className="cursor-pointer">اخبار</a>
              </li>
              <li className="my-4" onClick={() => navigate("/about-us")}>
                <a className="cursor-pointer">درباه‌ما</a>
              </li>
              <li className="my-4" onClick={() => navigate("/contact-us")}>
                <a className="cursor-pointer">تماس با ما</a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <Header whiteColor smallSize header="راه‌های ارتباطی" noAllItems />
            <ul className="text-white">
              <li className="my-4">
                <a className="flex items-center">
                  <LocationOnIcon className="self-start ml-2" />
                  <span className="text-sm">
                    تهران، یوسف آباد، بالاتر از میدان سلماس خیابان شهریار نبش
                    خیابان ۱۴ پلاک ۳۹
                  </span>
                </a>
              </li>
              <li className="my-4">
                <a className="flex items-center">
                  <PhoneIcon className="self-start ml-2" />
                  <span className="text-sm">۰۲۱-۷۵۳۳۱۶۵۰</span>
                </a>
              </li>
              <li className="mb-4 mt-8 flex justify-center md:justify-start">
                <a
                  target="_blank"
                  href="https://instagram.com/moraghebbime?igshid=ODkwYmMyNzQ1NA=="
                >
                  <img
                    className="w-6 ml-8 transition-all hover:scale-125 cursor-pointer"
                    src={instagramIcon}
                  />
                </a>
                <a target="_blank" href="https://t.me/moraghebbime">
                  <img
                    className="w-6 ml-8 transition-all hover:scale-125 cursor-pointer"
                    src={telegramIcon}
                  />
                </a>
                <a>
                  <img
                    className="w-6 ml-8 transition-all hover:scale-125 cursor-pointer"
                    src={twitterIcon}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex items-center mt-2 px-8">
          <a href="https://e-rasaneh.ir/Certificate/79636" target="_blank">
            <div className="bg-white  p-2 rounded-full w-12 h-12 transition-all hover:scale-125 cursor-pointer">
              <img className="w-full " src={resane} />
            </div>
          </a>
          <span className="leading-8 text-white text-sm mr-4">
            عضو سامانه جامع رسانه‌های کشور
          </span>
        </div>
        <div className="flex justify-center mt-8 pb-4 text-center">
          <span className="text-sm text-white">
            تمامی حقوق مادی و معنوی این سایت متعلق به شرکت ایرانیان‌پوشش
            می‌باشد.
          </span>
        </div>
      </div>
    </>
  );
};

export default Footer;
